/**
 * Lexemes.js
 * Description: Receives data from ../analyzer/lexer.js and Renders lexemes and its classification as a table
 */

import { useContext } from "react";

import {
  Table,
  TableCaption,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
} from "@chakra-ui/react";

import { context } from "../context/GlobalState";

const Lexemes = () => {
  const { state } = useContext(context);
  return (
    <Table variant="striped" colorScheme="blue">
      <Thead>
        <Tr>
          <Th>Token</Th>
          <Th>Classification</Th>
        </Tr>
      </Thead>
      <Tbody>
        {state.tokens &&
          state.tokens.map((i, idx) => (
            <Tr>
              <Td>{i.token}</Td>
              <Td>{i.type}</Td>
            </Tr>
          ))}
      </Tbody>
      <TableCaption flex={1}>
        Lexeme is the smallest syntactic unit of a programming language
      </TableCaption>
    </Table>
  );
};

export default Lexemes;
